import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

export const cancelSensorOrder = async (projectId, orderId) => {
  const apiPath = `projects/${projectId}/renolog/sensor-orders/${orderId}/cancel`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);
  return response.data;
};
